import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalContent, ModalFooter } from 'fronton-react';
import { LeadResponseStatus } from 'modules/leads';
import { createElementKey } from 'utils';
import { SectionSubTitle } from 'common/components/section-subtitle';
import { Button } from '../../../button';
import { Typography } from '../../../typography';
import { RESULT_MODAL_CONTENT } from './result-modal-constants';
import { textStyle, buttonWrapper, modalHeader, modalFooter } from './result-modal-styles';

type ResultModalProps = {
  isOpen: boolean;
  onClose: () => void;
  leadRequestStatus: LeadResponseStatus;
};

/**
 * View компонент модалного окна с результатом запроса консультации
 */
export const ResultModal = React.memo(({ isOpen, onClose, leadRequestStatus }: ResultModalProps) => {
  const { t } = useTranslation();
  const modalContent = React.useMemo(() => RESULT_MODAL_CONTENT[leadRequestStatus], [leadRequestStatus]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal onClose={onClose} overlayClose={false} overlayType="medium" show={isOpen} size="s">
      <SectionSubTitle className={modalHeader} as="p" margin="s">
        {t(modalContent.title, { ns: 'consultation-form', defaultValue: modalContent.defaultValue.title })}
      </SectionSubTitle>

      <ModalContent>
        {modalContent.text.map((text: string, index: number) => (
          <Typography
            key={createElementKey('result-modal', index)}
            className={textStyle}
            size="body_short"
            variant="m">
            {t(text, { ns: 'consultation-form', defaultValue: modalContent.defaultValue.text[index] })}
          </Typography>
        ))}
      </ModalContent>

      <ModalFooter className={modalFooter}>
        <div className={buttonWrapper}>
          <Button onClick={onClose} wide>
            {t(modalContent.button, {
              ns: 'consultation-form',
              defaultValue: modalContent.defaultValue.button,
            })}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
});
